<template lang="html">
  <div class="container-pad">
    <rare-home-products-candid-ats :isHeader="true" @jumpToForm="jumpToForm" />

    <rare-call-out-box
      CallOutTitle="Number one in the market"
      CallOutColor="grey"
    />

    <rare-comparison-table
      :headers="tableHeaders"
      :rows="tableRows"
    />

    <rare-call-out-box
      CallOutTitle="WE PROCESS MORE LEGAL GRADUATE RECRUITMENT APPLICATIONS THAN ANYONE ELSE"
      CallOutColor="grey"
    />

    <div id="ats-chart-wrapper">
      <img :src="chart" id="ats-chart" />
    </div>

    <rare-call-out-box
      CallOutTitle="Candid ATS clients save 25 days per year"
      CallOutColor="grey"
    />

    <testimonial-carousel
      :slides="slides"
    />

    <rare-call-out-box
      CallOutTitle="AVAILABLE FOR EARLY CAREERS AND EXPERIENCED HIRES"
      CallOutColor="midgrey"
      paddingX="12%"
    />

    <home-products-candid-ats-main-section />

    <rare-contact-form :product="'Candid ATS'" />

    <rare-awards/>
  </div>
</template>

<script>
import Chart from '@/assets/img/ats-chart.svg';
import Alice from '@/assets/img/photos/testimonials/ats/Alice.png';
import Kat from '@/assets/img/photos/testimonials/ats/Kat.png';
import Kate from '@/assets/img/photos/testimonials/ats/Kate.png';
import Matthew from '@/assets/img/photos/testimonials/ats/Matthew.png';

import Freshfields from '@/assets/img/logos/testimonial-logos/freshfields.png';
import FootAnstey from '@/assets/img/logos/testimonial-logos/footantsey.png';
import StephensonHarwood from '@/assets/img/logos/testimonial-logos/stephenson-harwood.png';
import HarbottleLewis from '@/assets/img/logos/testimonial-logos/harbottle-lewis.png';

import RareCallOutBox from '../../../components/commonSections/RareCallOutBox';
import RareComparisonTable from '../../../components/commonSections/RareComparisonTable';
import RareContactForm from '../../../components/forms/RareContactForm';
import RareAwards from '../../../components/carousels/awardsCarousel';
import TestimonialCarousel from '../../../components/carousels/testimonialCarousel/testimonialCarousel';

import RareHomeProductsCandidAts from '../components/RareHomeProductsCandidAts';
import homeProductsCandidAtsMainSection from './components/homeProductsCandidAtsMainSection';

export default {
  name: 'homeProductsCandidAts',
  props: {
  },
  components: {
    'rare-call-out-box': RareCallOutBox,
    'rare-home-products-candid-ats': RareHomeProductsCandidAts,
    'rare-comparison-table': RareComparisonTable,
    'home-products-candid-ats-main-section': homeProductsCandidAtsMainSection,
    'rare-contact-form': RareContactForm,
    'testimonial-carousel': TestimonialCarousel,
    'rare-awards': RareAwards,
  },
  data() {
    return {
      chart: Chart,
      slides: [
        {
          quote: 'Candid has opened up a whole new world of data for us, and we are able to view that data in real time ' +
            'through an application window. It is allowing us to be much more data-driven as a team, and is already ' +
            'providing us with powerful insights to inform our future recruitment practices.',
          img: Alice,
          name: 'Alice Lines',
          position: 'Head of Early Careers',
          logo: Freshfields,
          id: 0,
        },
        {
          quote: 'The reporting is a dream.',
          img: Kat,
          name: 'Kat Crisp',
          position: 'Early Careers Manager',
          logo: FootAnstey,
          id: 1,
        },
        {
          quote: 'WOW, WHAT A DIFFERENCE CANDID HAS MADE. FROM REPORTING, TO DESIGNING A SYSTEM THAT REALLY WORKS FOR ' +
            'US, THROUGH TO THE CANDIDATE EXPERIENCE. IT’S A BETTER WAY OF TRACKING APPLICATIONS AND REPORTING ON THE ' +
            'DATA - ALL IN ONE CENTRAL PLACE. IT’S NOT ONLY MADE OUR LIVES EASIER, BUT ALSO MAKES US BETTER ' +
            'PROFESSIONALS, AS WE CAN SHOW ROI - NOT ONLY ON THE PRODUCT ITSELF, BUT FOR ALL OUR CAMPUS INITIATIVES.',
          img: Kate,
          name: 'Kate Doyle',
          position: 'Senior Future Talent Manager',
          logo: StephensonHarwood,
          id: 2,
        },
        {
          quote: 'I use Candid for lateral recruitment. The system is really user friendly, the data we get from ' +
            'it is fantastic. The system allows you to drill down into all the different strands, which ' +
            'has really helped us to focus our recruitment. For ease of use it’s fantastic, we get great feedback ' +
            'from agencies, I really couldn’t fault it.',
          img: Matthew,
          name: 'Matthew Hatton',
          position: 'People Advisor',
          logo: HarbottleLewis,
          id: 3,
        },
      ],
      tableHeaders: [
        'Feature',
        'Candid ATS',
        'Legal ATS competitors',
      ],
      tableRows: [
        {
          feature: 'Low cost; contextual data sometimes offered free',
          rare: false,
          competitor: true,
        },
        {
          feature: 'Law.com award winner',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Real time analytics reporting in the ATS, free for all users',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Platinum-level ISO27001 information security enabling safe use of sensitive personal data in decision-making',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Adverse impact reporting',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Industry benchmarking in product',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Integrated events platform with instant return on investment included',
          rare: true,
          competitor: false,
        },
        {
          feature: 'Best-in-class data and reporting on specific disabilities and ethnicity',
          rare: true,
          competitor: false,
        },
      ],
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    jumpToForm() {
      const element = document.getElementById('rare-contact-form');
      const y = element.getBoundingClientRect().top + (window.pageYOffset - 330);

      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 === true) {
        document.getElementById('validationAnchor').scrollIntoView();
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container-pad {
  padding-top: 80px;
}

#ats-chart-wrapper {
  display: flex;
  justify-content: center;
}

#ats-chart {
  width: auto;
  // max-width: 80vw;
  max-height: 95vh;
  margin: 0 auto 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCandidAts/homeProductsCandidAts.vue